// SkillX admission verification — shared constants.
//
// Status values mirror course_enrollment.skillx_verification_status
// (node-portal util/data/constants.js SKILLX_VERIFICATION_STATUS).

export const SKILLX_VERIFICATION_STATUS = Object.freeze({
  PENDING: 0,
  VERIFIED: 1,
  CRO_NOTIFIED: 2,
});

// Chip styling per status, and the filter chips above the grid. `summaryKey`
// is the field in meta.summary that holds the count.
export const SKILLX_VERIFICATION_FILTERS = Object.freeze([
  { key: 'all', label: 'All', summaryKey: 'total' },
  { key: String(SKILLX_VERIFICATION_STATUS.PENDING), label: 'Pending', summaryKey: 'pending' },
  { key: String(SKILLX_VERIFICATION_STATUS.CRO_NOTIFIED), label: 'CRO Notified', summaryKey: 'croNotified' },
  { key: String(SKILLX_VERIFICATION_STATUS.VERIFIED), label: 'Verified', summaryKey: 'verified' },
]);

export const SKILLX_VERIFICATION_CHIP = Object.freeze({
  [SKILLX_VERIFICATION_STATUS.PENDING]: { color: '#9A6B00', bg: '#FFF4D6' },
  [SKILLX_VERIFICATION_STATUS.VERIFIED]: { color: '#2E7D62', bg: '#E3F4EC' },
  [SKILLX_VERIFICATION_STATUS.CRO_NOTIFIED]: { color: '#B23B3B', bg: '#FDE7E7' },
});

// Screen filters kept across refreshes (localStorage, per user). The grid's own
// search/page are not kept.
export const SKILLX_VERIFICATION_FILTERS_STORAGE_KEY = 'skillx-admission-verification-filters';
export const SKILLX_VERIFICATION_DEFAULT_FILTERS = Object.freeze({
  status: 'all',
  batch: null,
  fromDate: '',
  toDate: '',
});

// Permission title that gates the route (MyWorkspaceRouter) and the sidebar
// item. The permission row's title must match exactly.
export const SKILLX_ADMISSION_VERIFICATION_PERMISSION = 'Admission Verification Form';
